<template>
  <div class="hire-vehicles">
    <v-row justify="center">
      <v-col align="center" class="fixed i-blue col-12 z4">
          <h3 class="i-powderblue--text"><v-icon large>mdi-car</v-icon> Vehicle Hire</h3>

          <v-btn id="back-button"
            fab
            small
            depressed
            color="transparent"
            :left="true"
            fixed
            @click="goBack"
            class="z10">

            <v-icon class="i-darkblue--text">mdi-arrow-left</v-icon>
          </v-btn>

          <v-btn
            fab
            small
            :right="true"
            fixed
            @click="search=!search"
            class="mr-12 z10">

            <v-icon class="i-blue--text">mdi-magnify</v-icon>
          </v-btn>

          <v-btn
            fab
            small
            :right="true"
            fixed
            @click="filter=!filter"
            class="z10">

            <v-icon class="i-blue--text">mdi-filter</v-icon>
          </v-btn>
      </v-col>
    </v-row>
    
    <div id="widget-bar" class="wide fixed z3" v-show="search || filter">
      <v-col align="center" class="col-12">
        <br/>
        <br/>
        <br/>
        
        <transition name="slideYpos">
          <form v-show="search" id="search-form" class="col-lg-4 col-11" @submit="searchFn($event)">
            <input type="text" id="search-input" ref="searchBar" class="col-11 pl-3 pr-10 pt-2 pb-2 i-blue--border rounded" placeholder="type keyword"/>

            <v-btn id="search-btn"
              fab
              absolute
              depressed
              small
              @click="search=false">
              <v-icon class="i-lightrose--text">mdi-magnify</v-icon>
            </v-btn>
          </form>
        </transition>

        <transition name="slideYpos">
          <form v-show="filter" id="filter-form" class="col-lg-6 col-11 i-powderblue" @submit="filterFn($event)">
            <h4 class="i-darkblue--text">Filter Search</h4>
            <v-col class="col-11">
              <v-select label="filter by: vehicle type" :items="vehicleTypes" />
              <v-select label="filter by: vehicle make" :items="vehicleMakes.cars" />
              <v-select label="filter by: vehicle model" :items="vehicleMakes.cars" />
              <v-select label="filter by: vehicle class" :items="vehicleClass" />
              <v-select label="filter by: location" />
              <span>filter by: model year</span>
              <v-range-slider min="2000" max="2020" :prepend-icon="modelYearMin" :append-icon="modelYearMax" v-model="modelYear" />

              <span>filter by: rental price range</span>
              <v-range-slider min="5000" max="100000" :prepend-icon="priceRangeMin" :append-icon="priceRangeMax" v-model="priceRange" />
            </v-col>

            <v-col>
              <v-btn @click="filter=false">Apply</v-btn>
            </v-col>
          </form>
        </transition>

        <br v-if="filter"/>
        <br v-if="filter"/>
        <br v-if="filter"/>
      </v-col>
    </div>

    <v-row justify="center" class="pr-0 pl-0">
      <v-col class="col-12">
        <br/>
        <br/>
        <br/>
      </v-col>

        <v-col align="center" class="col-lg-6 col-12 pr-0 pl-0">
          <transition name="slideYneg">
            <v-card v-if="$keys[1]" elevation=4 align="left" class="catalog-item col-lg-10 col-11 center pt-0 pb-0 pr-0 pl-0 mt-lg-12 mt-5 mb-5 ml-lg-11 mr-lg-11">
              <v-row>
                <v-col class="col-10 pl-7">
                  <h4>
                    <span class="i-darkblue--text">Vehicle make</span>
                    <b class="i-blue--text"> . </b>
                    <span class="i-darkblue--text">Vehicle model</span>
                  </h4>
                </v-col>

                <v-col class="col-2">
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="transparent"
                    class="item-options z2"
                    :right="true"
                    small>
                    <v-icon class="i-blue--text">mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-img :src="require('../assets/images/hire_vehicles.jpeg')" height=250 cover />

              <v-row justify="center" class="i-darkblue">
                <v-col cols=4 class="pl-7">
                  <v-icon small class="i-powderblue--text">mdi-eye</v-icon>
                  <span class="i-powderblue--text"> 300</span>
                </v-col>

                <v-col cols=4 align="center">
                  <span class="mr-6 i-cream--text"> &#8358; 35,000</span>
                </v-col>

                <v-col cols=4 align="right" class="pr-7">
                  <v-btn class="i-blue--text">more</v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="i-darkblue"
                    :right="true"
                    small
                    class="add-to-wishlist z2">
                    <v-icon class="white--text">mdi-heart-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </transition>
        </v-col>

        <v-col align="center" class="col-lg-6 col-12 pr-0 pl-0">
          <transition name="slideYneg">
            <v-card v-if="$keys[2]" elevation=4 align="left" class="catalog-item col-lg-10 col-11 center pt-0 pb-0 pr-0 pl-0 mt-lg-12 mt-5 mb-5 ml-lg-11 mr-lg-11">
              <v-row>
                <v-col class="col-10 pl-7">
                  <h4>
                    <span class="i-darkblue--text">Vehicle make</span>
                    <b class="i-blue--text"> . </b>
                    <span class="i-darkblue--text">Vehicle model</span>
                  </h4>
                </v-col>

                <v-col class="col-2">
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="transparent"
                    class="item-options z2"
                    :right="true"
                    small>
                    <v-icon class="i-blue--text">mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-img :src="require('../assets/images/hire_vehicles.jpeg')" height=250 cover />

              <v-row justify="center" class="i-darkblue">
                <v-col cols=4 class="pl-7">
                  <v-icon small class="i-powderblue--text">mdi-eye</v-icon>
                  <span class="i-powderblue--text"> 300</span>
                </v-col>

                <v-col cols=4 align="center">
                  <span class="mr-6 i-cream--text"> &#8358; 35,000</span>
                </v-col>

                <v-col cols=4 align="right" class="pr-7">
                  <v-btn class="i-blue--text">more</v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="i-darkblue"
                    :right="true"
                    small
                    class="add-to-wishlist z2">
                    <v-icon class="white--text">mdi-heart-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </transition>
        </v-col>

        <v-col align="center" class="col-lg-6 col-12 pr-0 pl-0">
          <transition name="slideYneg">
            <v-card v-if="$keys[3]" elevation=4 align="left" class="catalog-item col-lg-10 col-11 center pt-0 pb-0 pr-0 pl-0 mt-lg-12 mt-5 mb-5 ml-lg-11 mr-lg-11">
              <v-row>
                <v-col class="col-10 pl-7">
                  <h4>
                    <span class="i-darkblue--text">Vehicle make</span>
                    <b class="i-blue--text"> . </b>
                    <span class="i-darkblue--text">Vehicle model</span>
                  </h4>
                </v-col>

                <v-col class="col-2">
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="transparent"
                    class="item-options z2"
                    :right="true"
                    small>
                    <v-icon class="i-blue--text">mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-img :src="require('../assets/images/hire_vehicles.jpeg')" height=250 cover />

              <v-row justify="center" class="i-darkblue">
                <v-col cols=4 class="pl-7">
                  <v-icon small class="i-powderblue--text">mdi-eye</v-icon>
                  <span class="i-powderblue--text"> 300</span>
                </v-col>

                <v-col cols=4 align="center">
                  <span class="mr-6 i-cream--text"> &#8358; 35,000</span>
                </v-col>

                <v-col cols=4 align="right" class="pr-7">
                  <v-btn class="i-blue--text">more</v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="i-darkblue"
                    :right="true"
                    small
                    class="add-to-wishlist z2">
                    <v-icon class="white--text">mdi-heart-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </transition>
        </v-col>

        <v-col align="center" class="col-lg-6 col-12 pr-0 pl-0">
          <transition name="slideYneg">
            <v-card v-if="$keys[4]" elevation=4 align="left" class="catalog-item col-lg-10 col-11 center pt-0 pb-0 pr-0 pl-0 mt-lg-12 mt-5 mb-5 ml-lg-11 mr-lg-11">
              <v-row>
                <v-col class="col-10 pl-7">
                  <h4>
                    <span class="i-darkblue--text">Vehicle make</span>
                    <b class="i-blue--text"> . </b>
                    <span class="i-darkblue--text">Vehicle model</span>
                  </h4>
                </v-col>

                <v-col class="col-2">
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="transparent"
                    class="item-options z2"
                    :right="true"
                    small>
                    <v-icon class="i-blue--text">mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-img :src="require('../assets/images/hire_vehicles.jpeg')" height=250 cover />

              <v-row justify="center" class="i-darkblue">
                <v-col cols=4 class="pl-7">
                  <v-icon small class="i-powderblue--text">mdi-eye</v-icon>
                  <span class="i-powderblue--text"> 300</span>
                </v-col>

                <v-col cols=4 align="center">
                  <span class="mr-6 i-cream--text"> &#8358; 35,000</span>
                </v-col>

                <v-col cols=4 align="right" class="pr-7">
                  <v-btn class="i-blue--text">more</v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    fab
                    depressed
                    absolute
                    color="i-darkblue"
                    :right="true"
                    small
                    class="add-to-wishlist z2">
                    <v-icon class="white--text">mdi-heart-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </transition>
        </v-col>

        <br/>
        <br/>
        <br/>
        <v-col cols=12 align="center" class="mt-12">
          <router-link to="legal">Terms and conditions apply</router-link>
        </v-col>

      <!-- WISHLIST BUTTON -->
      <v-col>
        <v-btn
          elevation=10
          fab
          small
          :right="true"
          fixed
          bottom
          class="mb-12">

          <v-icon class="i-lightrose--text">mdi-heart</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <br/>
  </div>
</template>

<script>
export default {
  name: 'i-vehicle-catalog',

  data: () => ({
    search: false,
    filter: false,

    vehicleTypes: [
      {text: 'All', value: "all"},
      {text: 'Sedans', value: "sedans"},
      {text: 'Trucks', value: "trucks"},
      {text: 'SUVs', value: "SUVs"},
      {text: 'Vans', value: "vans"},
      {text: 'Buses', value: "buses"},
      {text: 'Bikes', value: "bikes"},
      {text: 'Boats', value: "boats"},
      {text: 'Aircrafts', value: "aircrafts"},
    ],

    vehicleMakes: {
      aircrafts: [],
      bikes: [],
      boats:[],
      cars:[
        {text: 'Acura', value: 'Acura'},
        {text: 'Alfa-Romeo', value: 'Alfa-Romeo'},
        {text: 'Audi', value: 'Audi'},
        {text: 'Bentley', value: 'Bentley'},
        {text: 'BMW', value: 'BMW'},
        {text: 'Bugatti', value: 'Bugatti'},
        {text: 'Buick', value: 'Buick'},
        {text: 'Cadillac', value: 'Cadillac'},
        {text: 'Caterham', value: 'Caterham'},
        {text: 'Chevrolet', value: 'Chevrolet'},
        {text: 'Cooper', value: 'Cooper'},
        {text: 'Dodge', value: 'Dodge'},
        {text: 'Edag', value: 'Edag'},
        {text: 'Epsilon', value: 'Epsilon'},
        {text: 'Ferrari', value: 'Ferrari'},
        {text: 'Fiat', value: 'Fiat'},
        {text: 'Ford', value: 'Ford'},
        {text: 'Foton', value: 'Foton'},
        {text: 'GAC', value: 'GAC'},
        {text: 'GMC', value: 'GMC'},
        {text: 'Honda', value: 'Honda'},
        {text: 'Hummer', value: 'Hummer'},
        {text: 'Hyundai', value: 'Hyundai'},
        {text: 'IVM', value: 'IVM'},
        {text: 'Jaguar', value: 'jaguar'},
        {text: 'Jeep', value: 'Jeep'},
        {text: 'Koenigsegg', value: 'Koenigsegg'},
        {text: 'Lamborghini', value: 'Lamborghini'},
        {text: 'Lexus', value: 'Lexus'},
        {text: 'Lincoln', value: 'Lincoln'},
        {text: 'Lotus', value: 'Lotus'},
        {text: 'Maseratti', value: 'Maseratti'},
        {text: 'Mercedes', value: 'Mercedes'},
        {text: 'Mitsubishi', value: 'Mitsubishi'},
        {text: 'Nissan', value: 'Nissan'},
        {text: 'Opel', value: 'Opel'},
        {text: 'Pagani', value: 'Pagani'},
        {text: 'Peugeot', value: 'Peugeot'},
        {text: 'Quant', value: 'Quant'},
        {text: 'Rolls-Royce', value: 'Rolls-Royce'},
        {text: 'Subaru', value: 'Subaru'},
        {text: 'Suzuki', value: 'Suzuki'},
        {text: 'Tesla', value: 'Tesla'},
        {text: 'Toyota', value: 'Toyota'},
        {text: 'Volkswagen', value: 'Volkswagen'},
        {text: 'Volvo', value: 'Volvo'},
        {text: 'Webb', value: 'Webb'},
        {text: 'Weber', value: 'Weber'},
        {text: 'Yukon', value: 'Yukon'},
        {text: 'Zender', value: 'Zender'},
      ]
    },

    vehicleClass: [
      {text: 'Classic', value: 'Classic'},
      {text: 'Exotic', value: 'Exotic'},
      {text: 'Luxury', value: 'Luxury'},
      {text: 'Sports', value: 'Sports'},
      {text: 'Utility', value: 'Utility'},
    ],

    modelYear: [2000, 2020 ],

    modelYearMin: '',
    modelYearMax: '',

    priceRange: [5000, 65000],

    priceRangeMin: '',
    priceRangeMax: ''
  }),

  watch: {
    search() {
      if (this.search && this.filter) {
        this.filter = false
      }
    },

    filter() {
      if (this.filter && this.search) {
        this.search = false
      }
    },

    priceRange() {
      this.priceRangeMin = this.priceRange[0].toString()
      this.priceRangeMax = this.priceRange[1].toString()
    },

    modelYear() {
      this.modelYearMin = this.modelYear[0].toString()
      this.modelYearMax = this.modelYear[1].toString()
    }
  },

  methods: {
    goBack() {
      window.history.go(-1)
    },

    searchFn(event) {
      let searchBar = this.$refs.searchBar

      alert(searchBar.value)
      this.search = false

      event.preventDefault()
    },

    filterFn(event) {

      event.preventDefault()
    },
  },

  hasAnim: true
}
</script>

<style scoped>
#back-button {
  top: 4rem;
}

@media screen and (max-width: 1023px) {
  #widget-bar {
    width: 100% !important;
    max-height: 86vh;
    overflow: auto;
    background: rgba(0,0,0,0.25)
  }
}

@media screen and (min-width: 1024px) {
  #back-button {
    top: 4.5rem;
    left: 17rem
  }

  #widget-bar {
    width: 81% !important;
    max-height: 87vh;
    overflow: auto;
    background: rgba(0,0,0,0.25)
  }
}

#search-form {
  background: transparent;
  box-shadow: none !important;
}

#search-input {
  background: white !important;
}

#search-btn {
  background: transparent;
  transform: translateX(-2.7rem) translateY(2px);
}

.item-options {
  top: 0.25rem
}

.add-to-wishlist {
  top: 15rem
}

.catalog-item {
  overflow: hidden !important;
}
</style>
